import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classes from './myCV.module.scss';
import { MyUploadedCV, WorkHistory, Skills, Educations, TrainingsAndCertificates } from './components';
import ProfileWrapper from './components/ProfileWrapper/ProfileWrapper';
import { setNotification } from '../../../actions/appNotifications';
import { appNotificationsTypes } from '../../../utils/constants';

function MyCV() {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.user.profile);
  const profileError = useSelector((state) => state.user.error);
  const profilePending = useSelector((state) => state.user.pendingFlag);
  const updatingError = useSelector((state) => state.cv.updatingError);
  const userId = localStorage.getItem('UserId');

  useEffect(() => {
    if (updatingError)
      dispatch(
        setNotification({
          type: appNotificationsTypes.ERROR,
          message: updatingError,
          duration: 3000
        })
      );
  }, [updatingError]);

  return (
    <ProfileWrapper profile={profile} error={profileError} pending={profilePending} userId={userId}>
      <MyUploadedCV cvName={profile?.CvName} />
      <hr className={classes.divider} />
      <WorkHistory />
      <hr className={classes.divider} />
      <Skills />
      <hr className={classes.divider} />
      <Educations />
      <hr className={classes.divider} />
      <TrainingsAndCertificates />
    </ProfileWrapper>
  );
}

export default MyCV;
